import { AccessSharingMenuIcon, ChevronRight } from 'app/components/icons';
import React from 'react';
import './EquipmentAccessSharingDialogItem.less';

interface Props {
  title: string;
  description?: string;
  icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  children?: React.ReactNode;
  onClick: () => void;
}

export default function EquipmentAccessSharingDialogItem({
  title,
  description,
  icon: Icon = AccessSharingMenuIcon,
  children,
  onClick,
}: Props) {
  return (
    <li className="equipment-access-sharing-dialog-item" onClick={onClick}>
      <Icon stroke="#909090" />

      <span className="equipment-access-sharing-dialog-item__content">
        <div className="equipment-access-sharing-dialog-item__main-information">
          <div className="equipment-access-sharing-dialog-item__info-column">
            <h3 className="equipment-access-sharing-dialog-item__item-title">
              {title}
            </h3>
            {description && (
              <p className="equipment-access-sharing-dialog-item__item-description">
                {description}
              </p>
            )}
          </div>

          <ChevronRight />
        </div>

        {children && (
          <div className="equipment-access-sharing-dialog-item__secondary-information">
            {children}
          </div>
        )}
      </span>
    </li>
  );
}
